<template>
  <div id="dis_reports_gen">
    <h2>This component needs to be revised</h2>
    <!-- <ReportsGen module="dis" :types="types" :filterfields="filters"/> -->
  </div>
</template>

<script>
// import ReportsGen from '@/../extern/library/ReportsGen'
export default {
  components: {
    // ReportsGen
  },
  data: () =>({
    filters: {
      dis_inventory: ["source", "loc", "product"],
      dis_products: ["strain", "brand", "type"]
    },
    types: [
      { type: "Products", table: "products" },
      { type: "Inventory", table: "inventory" },
      { type: "Sales/Transfers", table: "sales" },
      { type: "Work Orders", table: "wo" }
    ]
  })
}
</script>